import { FC } from "react"

import { useTranslation } from "react-i18next"

import { LabeledInput } from "components/inputs/LabeledInput"
import { SectionCard } from "components/settings/SectionCard"

import { EVENT_NAME_FIELDS } from "./constants"
import { EventNameFormFields, FormState } from "./types"

interface EventNamesSectionProps {
  form: FormState
  saving: boolean
  onEventNameChange: (key: keyof EventNameFormFields, value: string) => void
}

export const EventNamesSection: FC<EventNamesSectionProps> = ({ form, saving, onEventNameChange }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <SectionCard title={t("settings.customerio.events.title")} description={t("settings.customerio.events.description")}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {EVENT_NAME_FIELDS.map((key) => (
          <LabeledInput
            key={key}
            id={`cio-event-${key}`}
            label={t(`settings.customerio.events.fields.${key}`)}
            value={form.eventNames[key]}
            onChange={(v) => onEventNameChange(key, v)}
            disabled={saving}
            placeholder={t("settings.customerio.events.placeholder")}
          />
        ))}
      </div>
    </SectionCard>
  )
}
